export const splitEvery = <T>(maxLength: number, arr: T[]): T[][] => {
  const chunks = []
  let i = 0
  while (i < arr.length) {
    chunks.push(arr.slice(i, (i += maxLength)))
  }
  return chunks
}
